import { render, staticRenderFns } from "./DrumThicknessFieldWidget.vue?vue&type=template&id=a5045cec"
import script from "./DrumThicknessFieldWidget.vue?vue&type=script&lang=js"
export * from "./DrumThicknessFieldWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports